import React, { useEffect, useState } from "react";
import { Modal, Table } from "react-bootstrap";
import Loader, { LoaderType } from "../../component/common-component/Loader";
import { InvoiceTransaction } from "../../services/ReduxTookit/Slice/InvoiceRedux";
import Nodata from "../../component/common-component/Nodata";
import { commonservices } from "../../services/CommonServices";
import { useDispatch } from "react-redux";
import DemoLogo from "../../assets/images/quantummain.svg";
import moment from "moment";

const InvoiceTransactionListModal = ({ showModal, closeModal, payload }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(true);
    const [InvoiceTransactionData, setInvoiceTransactionData] = useState(null);



    const getInvoiceTransaction = async () => {
        setLoading(true);
        /*const body = { associationid: invoiceid, associationtype_term: "Workflow Invoice" };*/
        dispatch(InvoiceTransaction(payload))
            .then((response) => {
                if (response?.payload?.isValidate) {
                    setInvoiceTransactionData(response?.payload?.data?.data);
                }
                if (!response?.payload?.isValidate) {
                    setInvoiceTransactionData(null);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        getInvoiceTransaction();
    }, [payload]);
    return (
        <Modal
            show={showModal}
            onHide={closeModal}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    <div className="d-flex gap-2 align-items-center">
                        <h6>Invoice No:</h6>
                        <h6>{payload.invoiceno}</h6>
                    </div>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="table-wrapper-main">
                    <Table responsive>
                        <thead>
                            <tr>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Session ID</th>
                                <th>Payment ID</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <Loader type={LoaderType.TableRow} count={2} nooftd={4} />
                            ) : (
                                <>
                                    {InvoiceTransactionData ? (
                                        <>
                                            {InvoiceTransactionData?.map((item) => {
                                                return (
                                                    <tr key={`orderDetail-${item?.transactionid}`}>
                                                        <td>{commonservices.getStatus(item?.transactionstatus)}</td>
                                                        <td>{item?.transactiondate ? commonservices.getDateInFormatCustom(item?.transactiondate, null, "MM/DD/yyyy") : ""}</td>
                                                        <td>{item?.transactionuniqsessionid}</td>
                                                        <td>{item?.paymentintentid}</td>
                                                    </tr>
                                                );
                                            })}
                                        </>
                                    ) : (
                                        <tr>
                                            <td colSpan={4}>
                                                <Nodata />
                                            </td>
                                        </tr>
                                    )}
                                </>
                            )}
                        </tbody>
                    </Table>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default InvoiceTransactionListModal;
